const state = {
    user: {
        name:'',
        id:''
    },
    baseUrl:'http://weixinapi.cvddr.com',
	// baseUrl:'http://weixinapi-test.cvddr.com',
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js